<template>
  <ul class="menu-nav">
    <router-link
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-digital-marketing"></i>
          <span class="menu-text">
            {{ $t("MENU.DASHBOARD.TITLE") }}
          </span>
        </a>
      </li>
    </router-link>


    <li v-if="userType === 2|| userType === 1" class="menu-section">
      <h4 class="menu-text">{{ $t("MENU.COMPANY_MANAGEMENT.TITLE") }}</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>


       <router-link
      v-if="userType === 1"
      to="/company-management"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-home-2"></i>
          <span class="menu-text">{{ $t("MENU.COMPANY_MANAGEMENT.COMPANY") }}</span>
        </a>
      </li>
    </router-link>

    <router-link
      v-if="userType === 2"
      to="/company"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">
            {{ $t("MENU.COMPANY_MANAGEMENT.COMPANY") }}
          </span>
        </a>
      </li>
    </router-link>

    <router-link
      v-if="userType === 2"
      to="/custom-color"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-pen"></i>
          <span class="menu-text">
            {{ $t("MENU.CUSTOM_COLOR") }}
          </span>
        </a>
      </li>
    </router-link>

    <li v-if="userType === 2" class="menu-section">
      <h4 class="menu-text">{{ $t("MENU.CAMPAIGN_MANAGEMENT.TITLE") }}</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      v-if="userType === 2"
      to="/campaign"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-event-calendar-symbol"></i>
          <span class="menu-text">
            {{ $t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN") }}
          </span>
        </a>
      </li>
    </router-link>
    <router-link
      v-if="userType === 1"
      to="/user"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon-user"></i>
          <span class="menu-text">{{ $t("MENU.USER_MANAGEMENT.USER") }}</span>
        </a>
      </li>
    </router-link>

  </ul>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "KTMenu",
  computed: {
    ...mapState({
      userType: state => state.auth.userType
    })
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
